define(['angular', 'moment'], function(angular, moment) {


    /**
     * @class CommonService
     */
    function CommonService($window) {
        var self = this;

        self.generateUID = function generateUID() {
            return ('0000' + ((Math.random() * Math.pow(36, 4)) << 0).toString(36)).slice(-4);
        };

        /**
         * Check if a given date range is valid or not
         * @param start, end: dates (as accepted types by moment js) for the date range
         * @return {Boolean}
         */
        self.checkDateRange = function checkDateRange(start, end) {
            return moment(end).isSameOrAfter(start);
        };

        /**
         * Check if the given date is between 2 dates (inclusive bounds)
         * @param  {String}  date
         * @param  {String}  start
         * @param  {String}  end
         * @return {Boolean}
         */
        self.isInDateRange = function isInDateRange(date, start, end) {
            return moment(date).isBetween(start, end, null, '[]');
        };

        /**
         * Check if a given strign ends with a particular suffix (function added in ES6)
         * @param  {String} string
         * @param  {String} suffix
         * @return {Boolean}
         */
        self.endsWith = function endsWith(string, suffix) {
            return string.indexOf(suffix, string.length - suffix.length) !== -1;
        };

        /**
         * Formatting names with capital lastname
         * @param  {String} firstname
         * @param  {String} lastname
         * @return {String} formatted name
         */
        self.getPersonFullName = function getPersonFullName(firstname, lastname) {
            return lastname.toUpperCase() + ' ' + firstname;
        };

        self.b64toBlob = (content, contentType) => {
            contentType = contentType || '';
            const sliceSize = 512;
            // method which converts base64 to binary
            const byteCharacters = $window.atob(content);

            const byteArrays = [];
            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                const slice = byteCharacters.slice(offset, offset + sliceSize);
                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }
            const blob = new Blob(byteArrays, {
                type: contentType
            }); // statement which creates the blob
            return blob;
        };

        return self;
    }

    CommonService.$inject = ['$window'];

    function updater(clientService, $interval, $root, $log, orderService, $timeout) {
        var timer;

        function sendUpdates() {
            var isNotifications = orderService.isSomethingToSynchronize();

            clientService
                .sendDirtyClients()
                .then(function() {
                    return orderService.sendDirtyOrders();
                })
                .then(function() {
                    return orderService.sendDirtyOrdersToSign();
                })
                .then(function() {
                    return orderService.sendDirtyOrdersToUpdateCPI();
                })
                .then(function() {
                    return orderService.sendDirtyOrdersToPublishCPI();
                })
                .then(function() {
                    return orderService.sendDirtyOrdersToCancel();
                })
                .then(function() {
                    orderService.sendDirtyOrdersToCancelAndReplace();
                })
                .then(function() {
                    orderService.sendDirtyOrdersToDuplicate();
                })
                .then(function() {
                    return orderService.sendDirtyOrdersToLose();
                })
                .then(function() {
                    return orderService.sendDirtyOrdersReadyForX3Integration();
                })
                .then(function(){
                    return orderService.sendDirtyOrdersRealDateSignature()
                })
                .then(function() {
                    return orderService.sendDirtyOrdersChangeClient().then(function() {
                        if (isNotifications) {
                            $root.$broadcast('synchro-off');
                        }
                    });
                });
        }

        function timerfn() {
            if (!$root.online) {
                return;
            }

            sendUpdates();
        }

        function removetimer() {
            // Make sure that the interval is destroyed too
            return timer && $interval.cancel(timer);
        }

        function addtimer() {
            $log.info('offline event timer');
            $timeout(sendUpdates, 20000);
            $log.info('20s timer sendUpdates');
            return timer || $interval(timerfn, 60 * 1000);
        }

        timer = addtimer();

        $root.$on('online', addtimer);
        $root.$on('offline', removetimer);
        $root.$on('$destroy', removetimer);
    }

    updater.$inject = ['clientService', '$interval', '$rootScope', '$log', 'orderService', '$timeout'];

    angular
        .module('app.bdc.common.commonService', [])
        .factory('commonService', CommonService)
        .run(updater);
});
